import { render, staticRenderFns } from "./ArrestStatusColumn.vue?vue&type=template&id=70482e0b&"
import script from "./ArrestStatusColumn.vue?vue&type=script&lang=ts&"
export * from "./ArrestStatusColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ArrestStatusColumn.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports